<script setup lang="ts">
type RouterLinkOptions = ExtractPropTypes<typeof RouterLink>['options'];

import { RouterLink } from 'hybridly/vue';

const props = defineProps<{
  href?: string;
  hrefOptions?: RouterLinkOptions;
  isExternalLink?: boolean;
  isDivided?: boolean;
}>();

const computedCardComponent = computed(() => {
  if (props.isExternalLink && props.href) {
    return 'a';
  }
  return props.href ? RouterLink : 'div';
});
</script>

<template>
  <div
    class="overflow-hidden rounded-lg bg-gradient-to-b from-slate-200 to-slate-300 p-px"
    :class="{
      'focus-within:bg-primary-300 focus-within:bg-none': href
    }"
  >
    <component
      :is="computedCardComponent"
      class="block overflow-hidden rounded-lg bg-white p-4"
      :href="href"
      :options="hrefOptions"
      :class="{
        'ring-inset hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-primary-300 active:bg-slate-100':
          href
      }"
    >
      <div class="flex flex-col gap-y-4">
        <slot name="header" />
        <div v-if="$slots.default" :class="{ 'divide-y divide-slate-200': isDivided }">
          <slot />
        </div>
        <slot name="footer" />
      </div>
    </component>
  </div>
</template>
